import { Injectable } from '@angular/core';
import { ErrorListComponent, ErrorType } from '../components/error-list/error-list.component';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorListService {
  errorData = new Subject<any>();
  errorListComponent?: ErrorListComponent;
  readonly field1 = 'row_number';
  readonly field2 = 'errors';
  readonly field3 = 'warnings';
  readonly field4 = 'transfection_number';

  setErrorData(data: any) {
    this.errorData.next(data);
  }

  getErrorData() {
    return this.errorData.asObservable();
  }

  processErrorList(data: any) {
    let errorList: any[] = [];
    let errorTableHead: ErrorType[] = [];
    if(!data){
      return { errorList, errorTableHead };
    }
    if (data.invalid_rows?.length) {
      errorTableHead = [
        { head: 'Row Number', field: this.field1 },
        { head: 'Errors', field: this.field2, isRepeated: true },
      ];
      if(data.invalid_rows[0][this.field4]){
        errorTableHead[0] = { head: 'Transfection Number', field: this.field4 };
      }
      for (const error of data.invalid_rows) {
        const errorEntry: any = {};
        if(error[this.field1]){
          errorEntry[this.field1] = error[this.field1];
        }
        if(error[this.field2]?.length){
          errorEntry[this.field2] = error[this.field2];
        }
        if(error[this.field4]){
          errorEntry[this.field4] = error[this.field4];
        }
        if(Object.keys(errorEntry).length){
           errorList.push(errorEntry);
        }
      }
    } else if (data.errors?.length) {
      errorTableHead = [{ head: 'Errors', field: this.field2, isRepeated: true }];
      errorList = [{ [this.field2]: data[this.field2] }];
    } else if (data.warnings?.length) {
      errorTableHead = [{ head: 'Warnings', field: this.field3, isRepeated: true }];
      errorList = [{ [this.field3]: data[this.field3] }];
    }
    return { errorList, errorTableHead };
  }
}
